var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    className: "download_svg__pbs-download",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#download_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.998 13.06a1 1 0 0 0-1.001 1.001v3.55H2.003v-3.55a1.002 1.002 0 0 0-2.003 0v4.552a1 1 0 0 0 1.002 1.002h17.996A1 1 0 0 0 20 18.613v-4.552a1 1 0 0 0-1.002-1.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.279 13.713a1.076 1.076 0 0 0 1.47 0l3.604-3.603a1.002 1.002 0 1 0-1.416-1.417l-1.894 1.897V1.002A1 1 0 0 0 10.041 0h-.054a1 1 0 0 0-1.002 1.002v9.588L7.092 8.693a1.002 1.002 0 0 0-1.417 1.417z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "download_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v19.615H0z"
  })))));
};
export default SvgDownload;